import { useState } from 'react';
import { useGranularEffect } from 'granular-hooks';

import classes from './Dropdown.module.css';
import Select from 'react-select'
import Image from './Image';

function Dropdown(props) {
	let initialSelection = null;
	let options = [];
	props.values.forEach((attribute, index) => {
		options[index] = {value: attribute.id, label: attribute.value, attrTypeId: attribute.typeID, maavStep: attribute.maavStep};
		if(typeof(props.selected[props.values[0].typeID]) !== "undefined" && props.selected[props.values[0].typeID].attrId === attribute.id) {
			initialSelection = options[index];
		}
	});

	const [selectedOption, setSelectedOption] = useState(initialSelection);
	const [openInfo, setOpenInfo] = useState(true);
	const filter = props.filter;

	useGranularEffect(() => {
		if(selectedOption !== null && (initialSelection === null || selectedOption.value !== initialSelection.value)) {
			filter(selectedOption.attrTypeId, selectedOption.value, selectedOption.maavStep);
		}
	}, [selectedOption], [filter]);

	return (
		<li className={classes.container} >
			{props.step >= props.maavStep &&
				<section>
					<div className={classes.label}>
						<h3 className={classes.attrName}>{props.attrName}
							{(props.maavInfo !== null) &&
								<span className={classes.hover_help}>
								<span className={classes.in_circle} onClick={() => setOpenInfo(true)}>?</span>
								{openInfo &&
									<span className={classes.infographic}>
										<span className={classes.close + " fa fa-times"} onClick={() => setOpenInfo(false)}></span>
										<Image
											key={props.maavStep}
											id={props.maavStep}
											name={"maav-infographic"}
											filename={props.maavInfo.filename}
											filetype={props.maavInfo.filetype}
											filename_webp={props.maavInfo.filename_webp}
										/>
									</span>
								}
								</span>
							}
						</h3>
					</div>
					<Select
						defaultValue={selectedOption}
						onChange={setSelectedOption}
						options={options}
					/>
				</section>
			}
			{(props.maavMedia !== null && props.step === props.maavStep) &&
			<div>
				<Image
					key={props.maavStep}
					id={props.maavStep}
					name={"maav-banner"}
					filename={props.maavMedia.filename}
					filetype={props.maavMedia.filetype}
					filename_webp={props.maavMedia.filename_webp}
				/>
			</div> }
		</li>
	);
}

export default Dropdown;